import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Sparkles } from "lucide-react";
import confetti from "canvas-confetti";
import { PremiumFeaturesList } from "./PremiumFeaturesList";

interface PremiumCelebrationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const PremiumCelebration = ({ open, onOpenChange }: PremiumCelebrationProps) => {
  const [showFeatures, setShowFeatures] = useState(false);

  useEffect(() => {
    if (open) {
      setShowFeatures(false);
      // Fire confetti
      const duration = 3000;
      const end = Date.now() + duration;

      const colors = ['#FFD700', '#FFA500', '#FF6B35'];

      (function frame() {
        confetti({
          particleCount: 3,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors: colors
        });
        confetti({
          particleCount: 3,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors: colors
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      }());

      // Show features after celebration
      setTimeout(() => setShowFeatures(true), 1500);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        {!showFeatures ? (
          <DialogHeader>
            <div className="flex justify-center mb-4">
              <div className="relative animate-scale-in">
                <Crown className="w-24 h-24 text-yellow-500 animate-pulse" />
                <Sparkles className="w-8 h-8 text-yellow-400 absolute -top-2 -right-2 animate-spin" style={{ animationDuration: '3s' }} />
              </div>
            </div>
            <DialogTitle className="text-3xl text-center bg-gradient-to-r from-yellow-400 to-amber-500 bg-clip-text text-transparent">
              Welcome to Premium! 🎉
            </DialogTitle>
            <DialogDescription className="text-center text-lg">
              You now have access to all premium features
            </DialogDescription>
          </DialogHeader>
        ) : (
          <>
            <PremiumFeaturesList />
            <div className="flex justify-center pt-4">
              <Button onClick={() => onOpenChange(false)} className="shadow-glow">
                Start Exploring
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
